import React, {useState, useEffect} from "react"
import safeData from "./safeData"
import puzzleAnswerData from "../puzzleAnswerData"

function Safe(props) {
    const [safeCode] = useState(puzzleAnswerData[3].safeCode)
    const [codeLength] = useState(8)
    const [safeInput, setSafeInput] = useState("")
    const [newInput, setNewInput] = useState(0)
    const [readoutText, setReadoutText] = useState("")
    const [count, setCount] = useState(-1)
    const [, setFlash] = useState(false)
    const [visibilityChange] = useState([
        "hidden", 
        "visibile",
        "hidden",
        "visible",
        "hidden",
        "visible",
        "hidden",
        "visible"
    ])
    
    function moveIndicator(event) {
        const {name} = event.target
        if (safeInput.length < codeLength) {
            setSafeInput(prevInput => prevInput + " " + name)
            setNewInput(safeData[name].position)
        } 
    }
    
    function completeSafe() {
        const show = "on"
        const text = "The safe swings open to reveal..."
        const trigger = "safe"
        props.callBack(show, text, trigger)
        props.callBackCompleted(trigger, true)
        props.callBackRevealClues("Decoding The Fifth Finger", "Unlocking The Safe")
    }
    
    useEffect(() => {
        const safeControl = "translate(-50%, -50%) rotate(" + newInput + "deg)"
        document.getElementById("combinationControl").style.transform = safeControl
        setReadoutText(safeInput.padEnd(codeLength, " _"))
        if (safeInput.length >= codeLength) {
            if (safeInput === safeCode) {
                setTimeout(() => completeSafe(), 750)
            } else {
                setCount(0)                  
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newInput, safeInput, codeLength, safeCode, props])
    
     useEffect(() => {
        if (count === 0) { 
            setFlash(() => setInterval(() => increaseFlashCount(), 250)) 
        } else if (count !== -1 && count < visibilityChange.length) {
            document.getElementById("safeReadout").style.color = "indianRed"
            document.getElementById("safeReadout").style.visibility = visibilityChange[count]
        } else {
            document.getElementById("safeReadout").style.color = "black"
            document.getElementById("safeReadout").style.visibility = "visible"
            setSafeInput("")
            setFlash(prevFlash => clearInterval(prevFlash))
        }
    }, [count, visibilityChange])
    
    function increaseFlashCount() {
        setCount(prevCount => prevCount + 1)
    }    
    
    const safeButtons = safeData.map((value, index) => {
        if (index > 0) {
            return (
                <button 
                    key={index} 
                    className={"safeNumber " + value.name} 
                    onClick={moveIndicator} 
                    name={index}>
                    {index}
                </button>)
        } else {
            return ""        
        }
    })
    
    return (
        <div>
            <h3>A safe hidden behind the picture frame... classic.</h3>
            <div className="imageTextWrapper safeOutline">
                <h1 id="safeReadout">{readoutText}</h1>
                    <div id="combinationControl">
                        <div className="combinationPointer"></div>
                        <img id="safeEye" src={"./images/partThree/eye.png"} alt="a hand drawn eye" />
                    </div>
                {safeButtons}
            </div>
        </div>
    )
}

export default Safe